import * as React from "react";
import FixturesPageContainer from "../../containers/fixtures/FixturesPageContainer";

export default class FixturesPage extends React.Component
{
    public render()
    {
        return (
            <section key="dashboard-body" className="dashboard-body">
                <FixturesPageContainer />
            </section>
        );
    }
}
